import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { Documents } from './views/Documents';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<Documents />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Documents)
	.build();

export default Layout;
